import React from 'react';
import { CardHeaderNav } from '@mummssoftware/common-ui';

/**
 * @param {{
 *   closeAction: function
 *   enableClinicalLinks: (boolean|undefined)
 *   hbcLocation: string
 *   patientNumber: string
 *   patient: import('../SharedPropDefs').Patient
 *   isMobile: (boolean|undefined)
 *   showClose: (boolean|undefined)
 *   onPrint: function
 *   onFax: (function|undefined)
 *   onEmail: (function|undefined)
 * }} props
 */
export const PatientCertNav = ({
  closeAction,
  enableClinicalLinks,
  patient,
  isMobile,
  showClose,
  onPrint,
  onFax,
  onEmail,
}) => (
  <CardHeaderNav
    patient={patient}
    enableClinicalLinks={enableClinicalLinks}
    showClose={isMobile ? false : showClose}
    closeForm={closeAction}
    isMobile={isMobile}
    printFn={onPrint}
    faxFn={onFax}
    emailFn={onEmail}
  />
);

export default PatientCertNav;
